import { useTranslation } from 'react-i18next';

const points = [
  { icon: 'ri-stack-line', titleKey: 'home.trust1Title', descKey: 'home.trust1Desc', accent: true },
  { icon: 'ri-eye-line', titleKey: 'home.trust2Title', descKey: 'home.trust2Desc' },
  { icon: 'ri-lightbulb-line', titleKey: 'home.trust3Title', descKey: 'home.trust3Desc' },
];

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section id="explore" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-16 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
          {t('home.trustTitle')}
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
          {t('home.trustCopy')}
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
        {points.map((point) => (
          <div
            key={point.titleKey}
            className={`rounded-lg p-6 ${
              point.accent ? 'bg-accent-100 text-accent-900' : 'bg-background-100'
            }`}
          >
            <span
              className={`flex h-12 w-12 items-center justify-center rounded-lg ${
                point.accent ? 'bg-accent-500 text-background-50' : 'bg-secondary-100 text-secondary-800'
              }`}
            >
              <i className={`${point.icon} text-xl`}></i>
            </span>
            <h3 className={`mt-4 font-heading text-lg font-semibold ${point.accent ? 'text-accent-900' : 'text-foreground-950'}`}>
              {t(point.titleKey)}
            </h3>
            <p className={`mt-2 text-sm leading-relaxed ${point.accent ? 'text-accent-800' : 'text-foreground-600'}`}>
              {t(point.descKey)}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}